// extracted by mini-css-extract-plugin
export default {"prevent-overflow":"Home_prevent-overflow__20Ilh"};